/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { GetExportRequestsQueryResponse } from "../types/GetExportRequests.ts"

export const getExportRequestsQueryKey = () =>
  [{ url: "/v1/export/export-requests" }] as const

export type GetExportRequestsQueryKey = ReturnType<
  typeof getExportRequestsQueryKey
>

/**
 * @summary Get export requests list
 * {@link /v1/export/export-requests}
 */
export async function getExportRequests(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetExportRequestsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/export/export-requests`, ...requestConfig })
  return res
}

export function getExportRequestsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getExportRequestsQueryKey()
  return queryOptions<
    ResponseConfig<GetExportRequestsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetExportRequestsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getExportRequests(config)
    },
  })
}

/**
 * @summary Get export requests list
 * {@link /v1/export/export-requests}
 */
export function useGetExportRequests<
  TData = ResponseConfig<GetExportRequestsQueryResponse>,
  TQueryData = ResponseConfig<GetExportRequestsQueryResponse>,
  TQueryKey extends QueryKey = GetExportRequestsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetExportRequestsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getExportRequestsQueryKey()

  const query = useQuery(
    {
      ...getExportRequestsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
